import List from "./list";
import Order from "../models/order";
import { excuseApi } from "../commons/http";

export default class Orders extends List {
  constructor() {
    super();
    this.total = 0;
  }
  async fetch(page, per_page, params={}) {
    const res = await excuseApi({
      path: '/orders',
      method: 'GET',
      params: {
        page: page,
        per_page: per_page,
        ...params,
      }
    })
    if (res.status === 200 || res.status === 201) {
      this.total = res.data.total;
      this.mapData(res.data.data);
    }
  }

  async fetchOrdersByUser(page, per_page, id, start_date, end_date, financial_status) {
    const res = await excuseApi({
      path: '/orders',
      method: 'GET',
      params: {
        page: page,
        per_page: per_page,
        user_id: id,
        start_date: start_date,
        end_date: end_date,
        financial_status: financial_status,
      }
    })
    console.log(res);
    if (res.status === 200 || res.status === 201) {
      this.total = res.data.total;
      this.mapData(res.data.data);
    }
  }

  async fetchByUserPackage(userPackageId) {
    try {
      const res = await excuseApi({
        path: `/user-packages/${userPackageId}/orders`,
        method: 'GET'
      });

      if (res.status === 200) {
        this.clear();
        this.mapData(res.data.data);
        return true;
      }
      return false;
    } catch (error) {
      throw error;
    }
  }

  mapData(data = []) {
    for (const item of data) {
      const order = new Order();
      order.mapData(item);
      this.add(order);
    }
  }
}
